import React from 'react'
import { Typography } from '@mui/material'
import TokTokDocDialog from '../../Common/Dialog'
import { RequesterHelpIcon } from '../../../assets/icons/icons'
import useStyles from './_styles'
import { PlannedExpertiseRequesterHelpDialogProps } from './_props'

export default function PlannedExpertiseRequesterHelpDialog({
  isOpen,
  onClose,
}: PlannedExpertiseRequesterHelpDialogProps) {
  const classes = useStyles()

  return (
    <TokTokDocDialog
        isOpen={isOpen}
        handleClose={onClose}
        handleCancel={onClose}
        cancelTitle="Fermer"
        title="Qu'est-ce qu'un requérant et pourquoi est-il obligatoire ?"
        dialogProps={{ fullScreen: false }}
        classNames={{
          dialogTitle: classes.helpRequesterTitle,
          paper: classes.helpDialogPaper,
        }}
      >
      <div className={classes.helpRequesterContent}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z" fill="#24C3CF"/>
        </svg>
        <Typography>
          Un requérant est le professionnel de santé à l'origine de la demande de
          téléexpertise. Ses informations sont tracées et obligatoires pour la
          facturation.
        </Typography>
      </div>
      <div className={classes.requesterDescription}>
        <Typography>
          Si le requérant à l'origine de cette demande n'est pas encore référencé dans la liste, veuillez l'ajouter pour créer sa fiche requérant, à l'aide du bouton dédié.
        </Typography>
      </div>
      <div className={classes.helpIcon}>
        <RequesterHelpIcon />
      </div>
    </TokTokDocDialog>
  )
}
